import $ from 'jquery';

const WorkOrderCategories = {
  init() {
    this.initializeAllForms();
    this.listenForNewForms();
    this.listenForUserSelectChanges();
    return true;
  },

  initializeAllForms() {
    $('.work-order-form-container').each((index, container) => {
      this.initializeForm($(container));
    });
  },

  initializeForm($container) {
    const $userSelect = $container.find('select[id^="work_order_user_id"]');
    const $categorySelect = $container.find('select[id^="work_order_professional_category_id"]');
    const $userHidden = $container.find('input[type="hidden"][name$="[user_id]"]');

    if (!$categorySelect.length || ($userSelect.length === 0 && $userHidden.length === 0)) {
      return false;
    }

    // Store the initially selected professional category ID
    const selectedCategoryId = $categorySelect.data('selected') || null;
    $container.data('selected-category-id', selectedCategoryId);

    // Remove any existing event listeners
    if ($userSelect.length) {
      $userSelect.off('.categories');

      // Bind events (change + select2 payloads) for this specific form
      $userSelect.on('change.categories select2:select.categories', () => {
        const userId = $userSelect.val();
        this.loadProfessionalCategoriesForForm($container, userId);
      });
    }

    // Initialize if user is already selected
    const currentUserId = ($userSelect.length && $userSelect.val()) || ($userHidden.length && $userHidden.val());
    if (currentUserId) {
      this.loadProfessionalCategoriesForForm($container, currentUserId);
    }

    return true;
  },

  listenForNewForms() {
    $(document).on('work-order-form-added', (event, $newForm) => {
      this.initializeForm($newForm);
    });
  },

  listenForUserSelectChanges() {
    $(document).off('change.categories select2:select.categories', 'select[id^="work_order_user_id"]');
    $(document).on('change.categories select2:select.categories', 'select[id^="work_order_user_id"]', (e) => {
      const $userSelect = $(e.currentTarget);
      const $container = $userSelect.closest('.work-order-form-container');
      const userId = $userSelect.val();

      this.loadProfessionalCategoriesForForm($container, userId);
    });
  },

  loadProfessionalCategoriesForForm($container, userId) {
    const $categorySelect = $container.find('select[id^="work_order_professional_category_id"]');
    const selectedCategoryId = $container.data('selected-category-id');

    if (!userId) {
      this.resetCategorySelect($categorySelect, 'Seleccionar usuari primer');
      return;
    }

    this.showLoadingState($categorySelect);

    $.ajax({
      url: `/users/${userId}/professional_categories`,
      type: 'GET',
      dataType: 'json',
      data: {
        include_selected: selectedCategoryId,
        format: 'json'  // Add format parameter
      },
      success: (categories) => this.handleCategoriesLoaded($categorySelect, categories, selectedCategoryId),
      error: (xhr, status, error) => {
        console.error('Error loading categories:', error);
        this.handleCategoriesError($categorySelect);
      }
    });
  },

  showLoadingState($categorySelect) {
    $categorySelect.empty();
    $categorySelect.append($('<option>', { value: '', text: 'Carregant categories...' }));
    $categorySelect.prop('disabled', true);
  },

  handleCategoriesLoaded($categorySelect, categories, selectedCategoryId) {
    $categorySelect.empty();
    $categorySelect.append($('<option>', { value: '', text: 'Seleccionar opció' }));

    if (categories && categories.length > 0) {
      $.each(categories, (index, category) => {
        const $option = $('<option>', {
          value: category.id,
          text: category.name
        });

        if (category.id === parseInt(selectedCategoryId)) {
          $option.prop('selected', true);
        }

        $categorySelect.append($option);
      });

      // If no specific selected category, default to first category.
      if (!selectedCategoryId || selectedCategoryId === '' || selectedCategoryId === null) {
        const firstVal = categories[0] && categories[0].id;
        if (firstVal !== undefined) {
          $categorySelect.val(firstVal);
        }
      }

      $categorySelect.prop('disabled', false);
    } else {
      this.resetCategorySelect($categorySelect, 'Aquest usuari no té categories');
    }

    // If using Select2, update it
    if ($categorySelect.hasClass('selectized') && typeof $.fn.select2 === 'function') {
      try {
        // Just trigger change to refresh the display, don't destroy/reinitialize
        $categorySelect.trigger('change.select2');
      } catch (e) {
        console.warn('Error updating select2 for categories:', e);
      }
    }
  },

  handleCategoriesError($categorySelect) {
    this.resetCategorySelect($categorySelect, 'Error carregant categories');
  },

  resetCategorySelect($categorySelect, message) {
    $categorySelect.empty();
    $categorySelect.append($('<option>', { value: '', text: message }));
    $categorySelect.prop('disabled', true);
  }
};

// Initialize when DOM is ready
$(document).ready(function() {
  WorkOrderCategories.init();
});

export default WorkOrderCategories;
